import { UsageFeatureProps } from '@employee-experience/common';
import { ILetterGenerationPdf } from '../../models/ILetterGenerationPdf';
import {
  ILetterGenerationRequest,
  ILetterSubmissionRequest,
} from '../../models/ILetterGenerationRequest';
import { ILetterMetadata } from '../../models/ILetterMetadata';
import { ILetterTemplate } from '../../models/ILetterTemplate';

export enum MetadataActionTypes {
  REQUEST_METADATA = 'REQUEST_METADATA',
  RECEIVE_METADATA = 'RECEIVE_METADATA',
  REQUEST_METADATA_FAILED = 'REQUEST_METADATA_FAILED',
  REQUEST_LETTER_GENERATION = 'REQUEST_LETTER_GENERATION',
  RECEIVE_LETTER_GENERATION = 'RECEIVE_LETTER_GENERATION',
  REQUEST_LETTER_GENERATION_FAILED = 'REQUEST_LETTER_GENERATION_FAILED',
  REQUEST_LETTER_SUBMISSION = 'REQUEST_LETTER_SUBMISSION',
  RECEIVE_LETTER_SUBMISSION = 'RECEIVE_LETTER_SUBMISSION',
  REQUEST_LETTER_SUBMISSION_FAILED = 'REQUEST_LETTER_SUBMISSION_FAILED',
}

export interface IRequestMetadataAction {
  type: MetadataActionTypes.REQUEST_METADATA;
  feature: UsageFeatureProps;
  selectedTemplate: ILetterTemplate;
}

export interface IReceiveMetadataAction {
  type: MetadataActionTypes.RECEIVE_METADATA;
  letterMetadata: ILetterMetadata;
}

export interface IReceiveMetadataFailedAction {
  type: MetadataActionTypes.REQUEST_METADATA_FAILED;
  errorMessage: string;
}

export interface IRequestLetterGenerationAction {
  type: MetadataActionTypes.REQUEST_LETTER_GENERATION;
  feature: UsageFeatureProps;
  letterGenerationRequest: ILetterGenerationRequest;
}

export interface IReceiveLetterGenerationAction {
  type: MetadataActionTypes.RECEIVE_LETTER_GENERATION;
  letterPdf: ILetterGenerationPdf;
}

export interface IReceiveLetterGenerationFailedAction {
  type: MetadataActionTypes.REQUEST_LETTER_GENERATION_FAILED;
  errorMessage: string;
}

export interface IRequestLetterSubmissionAction {
  type: MetadataActionTypes.REQUEST_LETTER_SUBMISSION;
  feature: UsageFeatureProps;
  letterSubmissionRequest: ILetterSubmissionRequest;
}

export interface IReceiveLetterSubmissionAction {
  type: MetadataActionTypes.RECEIVE_LETTER_SUBMISSION;
  crmActivityId: string;
}

export interface IReceiveLetterSubmissionFailedAction {
  type: MetadataActionTypes.REQUEST_LETTER_SUBMISSION_FAILED;
  errorMessage: string;
}

export type MetadataActions =
  | IRequestMetadataAction
  | IReceiveMetadataAction
  | IReceiveMetadataFailedAction
  | IRequestLetterGenerationAction
  | IReceiveLetterGenerationAction
  | IReceiveLetterGenerationFailedAction
  | IRequestLetterSubmissionAction
  | IReceiveLetterSubmissionAction
  | IReceiveLetterSubmissionFailedAction;
